import Vue from 'vue';
import Cookies from 'js-cookie';
import VueI18n from 'vue-i18n';
import lt from './lt';
import en from './en';
import { getDomainName } from '@/util/url';

const translations = {
  lt,
  en,
};

let locale = Cookies.getJSON('locale')?.toLowerCase();

if (!locale) {
  locale = 'lt';
  Cookies.set('locale', locale, {
    domain: getDomainName(),
  });
}

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale,
  messages: translations,
});

export default i18n;
